module.exports = __webpack_public_path__ + "static/Artboard_1-6753a69953717a41b6d8fcd7292ded7b.svg";